import { config } from '@soap/modules';

/** Primary Azure Functions base URL (e.g. VITE_FUNCTIONAPP_ROOT). */
export function getPrimaryFunctionAppRoot(): string {
  const root = config.vars?.[0]?.functionAppRoot;
  if (!root) {
    throw new Error('Backend URL is not configured. Set VITE_FUNCTIONAPP_ROOT and reload.');
  }
  return root;
}
